export default {
    props: {
        animationCollapse: {
            type: Boolean,
            kComposite: 'animation.collapse'
        }, 
        animationCollapseDuration: {
            type: Number,
            kComposite: 'animation.collapse.duration'
        }, 
        animationCollapseEffects: {
            type: String,
            kComposite: 'animation.collapse.effects'
        }, 
        animationExpand: {
            type: Boolean,
            kComposite: 'animation.expand'
        }, 
        animationExpandDuration: {
            type: Number,
            kComposite: 'animation.expand.duration'
        }, 
        animationExpandEffects: {
            type: String,
            kComposite: 'animation.expand.effects'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-treeview-vue-wrapper/src/KendoTreeView/Animation.js